import 'vuestic-ui/dist/styles/css-variables.css'
import 'vuestic-ui/dist/styles/essential.css'
import 'vuestic-ui/dist/styles/theme.css'
import 'vuestic-ui/dist/styles/typography.css'
import './scss/main.scss'

import { createApp } from 'vue'
import App from './App.vue'
import ClickableId from './components/ClickableId.vue'
import i18n from './i18n'
import { createVuestic } from 'vuestic-ui'
import { createGtm } from '@gtm-support/vue-gtm'
import VueDatePicker from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main.css'
import stores from './stores'
import router from './router'
import vuesticGlobalConfig from './services/vuestic-ui/global-config'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import VueApexCharts from 'vue3-apexcharts'
import pusherPlugin from './plugins/pusher'
// Initialize report job service (singleton)
import '@/services/reportJobService'
import '@/services/financeLedgerJobService'

const app = createApp(App)

app.use(stores)
app.use(router)
app.use(i18n)
app.use(pusherPlugin, {
  apiKey: import.meta.env.VITE_PUSHER_KEY || '1e7707caf4d4eca34616',
  cluster: import.meta.env.VITE_PUSHER_CLUSTER || 'ap2',
  authEndpoint: import.meta.env.VITE_PUSHER_AUTH_ENDPOINT || 'https://your-api-endpoint.com/pusher/auth',
})

app.use(createVuestic({ config: vuesticGlobalConfig }))
app.use(VueApexCharts)
if (import.meta.env.VITE_APP_GTM_ENABLED) {
  app.use(
    createGtm({
      id: import.meta.env.VITE_APP_GTM_KEY,
      debug: false,
      vueRouter: router,
    }),
  )
}
app.component('VueDatePicker', VueDatePicker)
app.component('ClickableId', ClickableId)
app.use(ElementPlus)
app.mount('#app')
